<template>
    <section class="flex flex-col min-h-screen bg-black">
        <NavBar />
        <div class="wrapper flex-grow flex bg-gray-100">
            <router-view class="flex-grow flex flex-col"></router-view>
        </div>
        <FooterComp />
    </section>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import FooterComp from "@/components/FooterComp.vue";

export default {
    name: "HomeLayout",
    components: {
        NavBar,
        FooterComp
    },
};
</script>

<style scoped>
.wrapper {
    background-color: #F5F5F5; /* Light gray background for content */
}
</style>
